import {
  ChatEventFileGroupReceivedContentDto,
  ChatEventFileReceivedContentDto,
  ChatEventTextReceivedContentDto,
  ChatMemberDto,
  MessageViewDto,
} from '@src/api-messenger';

import { MessageContentTypeEnum, MessageFileType, MessageModel } from '../message';
import { ChatMemberModel } from '../chat';

export const mapMessageTextToMessage = (content: ChatEventTextReceivedContentDto, createdAt: number): MessageModel => {
  return {
    chatId: content.chatId,
    id: content.messageId,
    userId: content.senderUserId,
    userName: content.senderUserName,
    replyMessageId: content.replyMessageId,
    replyMessageText: content.replyMessageText,
    dateCreated: numberToDate(createdAt), // TODO: на бэке нужно вернуть createdAt в content
    contentType: MessageContentTypeEnum.Text,
    content: {
      text: content.messageText,
    },
  };
};

export const mapMessageViewToMessage = (message: MessageViewDto, chatId: string): MessageModel => {
  const contentType = message.contentType
    ? getContentTypeForMessage(message.contentType)
    : (getContentTypeForMessage(message.file?.contentType) ?? (message.messageType as MessageContentTypeEnum));

  return {
    chatId,
    id: message.messageId,
    userId: message.senderUserId,
    userName: message.senderUserName,
    replyMessageId: message.replyMessageId,
    replyMessageText: message.replyMessageText,
    deliveredToAnyOne: message.deliveredToAnyOne,
    readAnyOne: message.readAnyOne,
    dateCreated: numberToDate(message.createdAt),
    contentType,
    content: {
      text: message.messageText,
      files: message.fileGroup?.files ?? (message.file ? [message.file] : undefined),
      emodji: message.emodjies ?? undefined,
    },
    reactions: message.emodjies,
  };
};

export const mapMessageFileToMessage = (content: ChatEventFileReceivedContentDto, createdAt: number): MessageModel => {
  return {
    chatId: content.chatId,
    id: content.messageId,
    userId: content.senderUserId,
    userName: content.senderUserName,
    replyMessageId: content.replyMessageId,
    replyMessageText: content.replyMessageText,
    dateCreated: numberToDate(createdAt), // TODO: на бэке нужно вернуть createdAt в content
    contentType: getContentTypeForMessage(content.contentType),
    content: {
      files: [
        {
          fileId: content.fileId,
          fileName: content.fileName,
          size: content.size,
          contentType: content.contentType,
        },
      ],
      text: content.messageText ?? undefined,
    },
  };
};

export const mapMessageGroupFilesToMessage = (
  content: ChatEventFileGroupReceivedContentDto,
  createdAt: number,
): MessageModel => {
  return {
    chatId: content.chatId,
    id: content.messageId,
    userId: content.senderUserId,
    userName: content.senderUserName,
    replyMessageId: content.replyMessageId,
    replyMessageText: content.replyMessageText,
    dateCreated: numberToDate(createdAt), // TODO: на бэке нужно вернуть createdAt в content
    contentType: getContentTypeForMessage(content.contentType),
    content: {
      files: content.files.map(file => {
        const normalizeFile: MessageFileType = {
          fileId: file.fileId,
          fileName: file.fileName,
          size: file.size,
          contentType: content.contentType,
        };
        return normalizeFile;
      }),
      text: content.messageText ?? undefined,
    },
  };
};

function numberToDate(value: number): Date {
  return new Date(value * 1000);
}

function getContentTypeForMessage(contentType?: string | null): MessageContentTypeEnum | null {
  return contentType
    ? contentType.includes('image')
      ? MessageContentTypeEnum.Image
      : MessageContentTypeEnum.File
    : null;
}

export const mapChatMemberToMember = (member: ChatMemberDto): ChatMemberModel => {
  return {
    userId: member.userId,
    userName: member.userName,
    isChatAdmin: member.isChatAdmin,
    isAvatarExists: member.isAvatarExists,
    online: false, // FIXME
  };
};
